import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const AddButton = React.memo(({ onClick, text }) => {
  return (
    // Remove btn-success
    <button className="btn btn-primary ml-auto" onClick={onClick}>
      <FontAwesomeIcon icon={faPlus} /> {text}
    </button>
  );
});

export default AddButton;
